export default __webpack_public_path__ + "static/card-image-4-ae915e4a744dd45ed40d1f481c77ea7f.png";